<app-header (toggleMenubar)="toggleMenu()"></app-header>
<div class="ng-content">
  <p-sidebar #menubar [visible]="isMenuVisible" position="left" [showCloseIcon]="false" styleClass="ng-menubar"
    [modal]="false">
    <app-menu (closeClicked)="isMenuVisible=$event" [itemsSetup]="itemsSetup"
      [itemsEmployeeInformation]="itemsEmployeeInformation" [itemsTimeKeeping]="itemsTimeKeeping"
      [itemsSalaryCalculation]="itemsSalaryCalculation" [itemsInsurancesAndOther]="itemsInsurancesAndOther" 
      [showSetup]="showSetup" [showEmployeeInformation]="showEmployeeInformation" [showTimeKeeping]="showTimeKeeping"
      [showSalaryCalculation]="showSalaryCalculation" [showInsurancesAndOther]="showInsurancesAndOther" className="np-menu">
    </app-menu>
  </p-sidebar>
  <reuse-tab></reuse-tab>
  <div style="margin-top: 15px;">
    <router-outlet></router-outlet>
  </div>
  
</div>
<app-footer></app-footer>
